// Generated by purs version 0.15.0
import * as $foreign from "./foreign.js";
var advancedPopover = function (node, v) {
    return $foreign.initAdvanced(node);
};
export {
    initAdvanced
} from "./foreign.js";
export {
    advancedPopover
};
//# sourceMappingURL=index.js.map
